export const ROUTES = {
  ai: {
    buddies: '/buddies',
    dialog: '/buddy',
  },
  aprender: {
    selectReview: '/aprender/select-review',
    difficult: '/aprender/difficult',
    learn: '/aprender/learn',
    review: '/aprender/review',
    speed: '/aprender/speed',
  },
  bienvenue: '/bienvenue',
  dashboard: '/dashboard',
  experiments: {
    feature: '/feature',
  },
  labs: '/labs',
  languages: '/languages',
  membot: {
    dialog: '/membot',
    select: '/communicate',
  },
  myActivities: '/my-activities',
  myJourney: '/my-journey',
  myLessons: '/my-lessons',
  myWords: '/my-words',
  onboarding: {
    choosePlan: '/choose-plan',
    selectLevel: '/select-level',
  },
  payment: {
    confirmation: `/payment/confirmation`,
    plans: '/payment/plans',
  },
  scenarios: {
    learn: '/learn',
    practice: '/practice',
  },
  settings: {
    learning: '/learning-settings',
    user: '/settings/',
  },
  signIn: '/signin',
  signOut: '/signout',
  video: {
    immerse: '/immerse',
    media: '/media',
  },
  wordlists: {
    choose: '/choose-wordlist',
    details: '/wordlist',
    main: '/wordlists',
    select: '/select-wordlists',
  },
} as const;
